import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import languageContext from "../context/language/languageContext";
import Navbar from "../components/Navbar";
import { useLocation } from "react-router-dom";
import { CalendarDays, Clock4, BadgeCheck } from "lucide-react";

const ViewAppointments = () => {
  const { setAlert, setMessage, setSessionTimeout } = useContext(languageContext);
  const [appointments, setAppointments] = useState([]);
  const location = useLocation();
  const patient_name = location.state?.patient_name || "Patient";

  const fetchAppointments = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;

    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/appointment_details",
        JSON.stringify({ id: patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setAppointments(response.data.data || []);
      }
    } catch (error) {
      if (error.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        setAlert(true);
        setMessage("Failed to fetch appointments. Try again later.");
        console.error(error);
      }
    }
  };

  useEffect(() => {
    fetchAppointments();
  }, []);

  const formatStatus = (status) => {
    if (status === "1") return { text: "Proposed", className: "bg-yellow-100 text-yellow-800" };
    if (status === "2") return { text: "Confirmed", className: "bg-green-100 text-green-700" };
    return { text: "Unknown", className: "bg-gray-200 text-gray-700" };
  };

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 to-white">
      <Navbar />

      <div className="max-w-5xl mx-auto w-full p-6">
        <div className="bg-white rounded-2xl shadow-lg p-6">
          <h2 className="text-3xl font-bold text-blue-800 mb-2 text-center">
            🗓️ Appointments
          </h2>
          <p className="text-center text-gray-600 mb-6">
            Viewing appointments for: <span className="font-semibold text-blue-900">{patient_name}</span>
          </p>

          {appointments.length === 0 ? (
            <div className="text-center text-gray-500 italic py-10">
              No appointments for this patient.
            </div>
          ) : (
            <div z="grid grid-cols-1 md:grid-cols-2 gap-5">
              {appointments.map((appointment) => {
                const { text, className } = formatStatus(appointment.status);
                return (
                  <div key={appointment.id} className="bg-blue-50 p-4 rounded-xl shadow-sm hover:shadow-md transition duration-200">
                    <div className="flex items-center gap-2 text-blue-800 font-semibold mb-2">
                      <BadgeCheck className="w-4 h-4" />
                      Appointment ID: {appointment.id}
                    </div>
                    <div className="flex items-center gap-2 text-gray-700 mb-1">
                      <CalendarDays className="w-4 h-4" />
                      <span>{appointment.date}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-700 mb-1">
                      <Clock4 className="w-4 h-4" />
                      <span>{appointment.time}</span>
                    </div>
                    <div className="mt-2">
                      <span
                        className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${className}`}
                      >
                        {text}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewAppointments;
